<!--
 * @Description: Description
 * @Author: dpw
 * @Date: 2025-01-216 11:46:23
 * @LastEditors: gaoyuanyuan
 * @LastEditTime: 2026-03-30 14:27:58
-->
<template>
    <div :class="['register-page', $i18n.locale]">
        <div class="navbar">
            <span>
                <img
                    src="@/assets/images/sidebar/arrow-left.png"
                    alt
                    class="menu-info"
                    @click.prevent="onClickLeft()"
                />
            </span>
        </div>
        <div class="header">
            <div v-if="!isCompleteEmail" class="title">{{ $t('login.bindEmailTitle') }}</div>
            <div v-else>
                <h2 v-if="headerTitle.length > 0">{{ headerTitle }}</h2>
                <h2 v-if="headerTitle.length > 0">{{ $t('login.bindEmailTips2') }}</h2>
            </div>
        </div>
        <!-- 邮箱绑定 -->
        <!-- 邮箱验证码登录 -->
        <div class="content">
            <div class="form">
                <div class="item">
                    <label for="email" v-if="$i18n.locale === 'tr-TR' || $i18n.locale === 'ar-AR'">{{
                        $t('login.email')
                    }}</label>
                    <label for="email" v-else>E-mail</label>
                    <div class="info">
                        <van-field
                            @blur="handleBlurReset($event)"
                            @focus="handleFouceReset($event)"
                            v-model.trim="form.email"
                            name
                            label
                            :placeholder="$t('login.formList[2].label')"
                            class="iteminput"
                        />
                    </div>
                </div>
                <div class="item">
                    <label for="verifyCode" class="codeLabel codeLabel-item">{{ $t('login.formList[1].label') }}</label>
                    <div class="info">
                        <div
                            class="placeholder_code"
                            v-if="!isFocus && $i18n.locale === 'ja-JP'"
                            @click="onPlaceholder"
                        >
                            {{ $t('login.formList[1].placeholder') }}
                        </div>
                        <input
                            :style="
                                $i18n.locale === 'zh-CN'
                                    ? 'padding-left: 50px'
                                    : $i18n.locale === 'es-ES' || $i18n.locale === 'it-IT' || $i18n.locale === 'tr-TR'
                                    ? 'padding-left: 10px'
                                    : 'padding-left: 20px'
                            "
                            autocomplete="off"
                            ref="verifyCode"
                            v-else
                            :disabled="isCodeInputDisabled"
                            v-model="form.code"
                            @blur="handleBlurReset($event)"
                            @focus="handleFouceReset($event)"
                            @input="validatorCode"
                            type="number"
                            label
                            :placeholder="$i18n.locale === 'ja-JP' ? '' : $t('login.formList[1].placeholder')"
                            name="verifyCode"
                            :border="false"
                            class="itemyzm"
                        />
                        <span
                            :class="{ 'is-disabled': isCodeBtnDisabledEmail }"
                            @click="handleSendCode"
                            class="get-code-btn"
                            >{{ codeText }}</span
                        >
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div class="footer">
            <div class="submit-btn">
                <div class="error-tips" v-if="erorTips">{{ erorTips }}</div>
                <van-button
                    :disabled="isMobileSubmitDisabled"
                    :class="{
                        'is-disabled': isMobileSubmitDisabled,
                        'custom-btn': true,
                    }"
                    @click.prevent="bindLogin"
                    @keyup.enter="bindLogin"
                    type="primary"
                    color="linear-gradient(90deg, #00E3C9 0%, #009FE8 100%)"
                    >{{ buttonName }}</van-button
                >
            </div>
        </div>
    </div>
</template>
<script>
import { sendValidationEmail, findAccount, updateMember, findCurrentMember } from '@/assets/js/apolloGql.js'
import { languageConfig, languageConfigM60 } from '@/assets/js/langObject'
import { isM60 } from '@/types/device.js'

export default {
    components: {},
    data() {
        return {
            isFocus: false,
            erorTips: '',
            isAutoLogin: false,
            areaCode: '',
            currentLanguage: '',
            languages: isM60() ? languageConfigM60 : languageConfig,
            form: {
                code: '',
                phone: '',
                email: '',
            },
            height: {
                isValid: false,
                value: '',
            },
            // 验证码定时器
            timer: '',
            // 获取验证码时间间隔 60s
            countDown: 60,
            codeText: '',
            // 验证码默认不能输入 验证码发送成功后才能输入
            isCodeInputDisabled: false,
            // 验证码是否正在发送状态
            isCodeSending: false,
            outTimeStamp: 0,
            // 提交按钮状态
            submitDisabled: false,
            loginInfo: JSON.parse(window.localStorage.getItem('loginInfo')),
            // 选择登录状态
            loginStatus: false,
            bindStatus: false, //  false 邮箱绑定  true手机号绑定
            timeTag: null,
            // 登录按钮是否正在加载中
            loginBtnState: false,
            showPassword: false, // 用于控制密码显示/隐藏
            isMobileSubmitDisabled: true,
            thirdLoginInfo: JSON.parse(window.localStorage.getItem('thirdLoginInfo')),
            memberInfo: undefined,
        }
    },

    computed: {
        isCodeBtnDisabledEmail() {
            return !this.form.email || this.isCodeSending
        },
        headerTitle() {
            let title = ''
            if (this.thirdLoginInfo && this.$route.query.type === 'complete') {
                let type = 'Google'
                if (this.thirdLoginInfo.type === 2) {
                    type = 'Facebook'
                }
                title = this.$t('login.bindEmailTips1', { item: type })
            }
            return title
        },
        buttonName() {
            let name = this.$t('login.bind')
            if (this.thirdLoginInfo && this.$route.query.type === 'complete') {
                name = this.$t('login.bindAndContinue')
            }
            return name
        },
        isCompleteEmail() {
            if (this.thirdLoginInfo && this.$route.query.type === 'complete') {
                return true
            }
            return false
        },
    },

    watch: {},

    beforeDestroy() {
        clearInterval(this.timer)
    },
    created() {
        // 默认语言配置
        const lang = localStorage.getItem('lang')
        if (!lang) {
            localStorage.setItem('lang', 'en-US')
        }

        this.codeText = this.$t('login.formList[0].placeholder')
        this.areaCode = this.languages.find((item) => item.value === this.$i18n.locale)?.no
        this.currentLanguage = this.languages.find((item) => item.value === this.$i18n.locale)?.label
    },
    mounted() {
        // 保留信息不被清空
        if (!this.isCompleteEmail) {
            this.findCurrentMember()
        }
    },

    methods: {
        mobileSubmitDisabled() {
            if (!this.loginStatus) {
                this.isMobileSubmitDisabled = this.form.code.length !== 4
            }
        },
        onPlaceholder() {
            this.isFocus = true
            this.$nextTick(() => {
                console.log(this.$refs.verifyCode)
                this.$refs.verifyCode.focus()
            })
        },
        togglePassword() {
            this.showPassword = !this.showPassword
        },

        onClickLeft() {
            this.$router.go(-1)
        },
        onCommand(lang) {
            let languageInfo = {}
            for (let index = 0; index < this.languages.length; index++) {
                if (lang === this.languages[index].label) {
                    languageInfo = this.languages[index]
                    break
                }
            }
            this.$i18n.locale = languageInfo.value
            this.areaCode = languageInfo?.no
            localStorage.setItem('lang', this.$i18n.locale)
            this.currentLanguage = lang
            this.codeText = this.$t('login.formList[0].placeholder')
            this.erorTips = ''
            this.form.phone = ''
            this.form.code = ''
            this.form.email = ''
            this.form.password = ''
        },
        // 失去焦点后重置背景
        handleBlurReset(e) {
            const email = this.form.email
            if (email === '') {
                this.$toast({
                    message: this.$t('login.formList[2].label'),
                    duration: 1500,
                })
                return
            }
            // eslint-disable-next-line no-useless-escape
            const emailorg =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (!emailorg.test(this.form.email)) {
                this.erorTips = this.$t('login.rule.email.requiredMsg')
            } else {
                this.erorTips = ''
            }

            if (this.form.code === '') {
                this.isFocus = false
            }
            this.outTimeStamp = e.timeStamp
            this.mobileSubmitDisabled()
            setTimeout(() => {
                if (this.outTimeStamp === e.timeStamp) {
                    this.resetBackground()
                }
            }, 100)
        },

        handleFouceReset(e) {
            this.outTimeStamp = e.timeStamp
            this.mobileSubmitDisabled()
        },

        // 重置iso下键盘收回后底部空白问题
        resetBackground() {
            window.scrollTo(0, 0)
        },
        validateForm() {
            let err
            if (!this.form.code) {
                // 请输入验证码
                err = this.$t('login.formList[1].placeholder')
            }

            // 判断验证码少于4位
            if (!this.loginStatus && this.form.code && this.form.code.length < 4) {
                err = this.$t('login.rule.authCode.requiredMsg')
            }
            if (!this.form.email) {
                err = this.$t('login.formList[2].label')
            } else {
                // eslint-disable-next-line no-useless-escape
                const email =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                if (!email.test(this.form.email)) {
                    err = this.$t('login.rule.email.requiredMsg')
                }
            }
            if (err) {
                this.erorTips = err
                return false
            }
            return true
        },
        // 倒计时
        countDownAction() {
            this.countDownTime = new Date().getTime()
            let that = this
            this.timeTag = setInterval(() => {
                that.countDown--
                that.codeText = `${this.$t('login.retransmission', { item: that.countDown })}`
                if (that.countDown === 0) {
                    that.isCodeSending = false
                    that.codeText = this.$t('login.formList[0].placeholder')
                    clearInterval(this.timeTag)
                    that.countDown = 60
                }
            }, 1000)
            this.timer = this.timeTag
        },

        // 发送验证码
        async handleSendCode() {
            let that = this

            // 判断按钮状态 禁用时不可点击
            if (this.isCodeBtnDisabledEmail) {
                return
            }
            that.form.code = ''
            // eslint-disable-next-line no-useless-escape
            const email =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (this.countDown === 60) {
                if (!email.test(this.form.email)) {
                    this.erorTips = this.$t('login.rule.email.requiredMsg')
                } else {
                    this.isCodeSending = true
                    // 验证码发送成功后可输入验证码
                    this.isCodeInputDisabled = false

                    this.$apollo
                        .mutate({
                            mutation: sendValidationEmail,
                            variables: {
                                email: this.form.email,
                            },
                        })
                        .then((res) => {
                            const data = res.data.sendValidationEmail
                            if (data.code === 200) {
                                this.countDownAction()
                                this.$toast({
                                    message: this.$t('login.success'),
                                    duration: 2000,
                                    className: 'success-toast',
                                })
                            } else if (data.code === 404) {
                                // 邮箱未注册提示文案
                                this.erorTips = this.$t('login.rule.email.patternMsg')
                            } else {
                                this.isCodeSending = false
                                this.$toast({
                                    message: this.$t('login.error'),
                                    duration: 1500,
                                    className: 'success-toast',
                                })
                            }
                        })
                        .catch((err) => {
                            console.error(err)
                            this.isCodeSending = false
                        })
                }
            }
        },
        // 绑定登录
        bindLogin() {
            // 完第三方登录邮箱
            this.$apollo
                .query({
                    query: findAccount,
                    fetchPolicy: 'network-only',
                    variables: {
                        email: this.form.email,
                        code: String(this.form.code) || 0,
                    },
                })
                .then((res) => {
                    const data = res.data.findAccount
                    this.loginBtnState = false
                    if (data.code == 200) {
                        // 账号存在
                        this.erorTips = this.$t('login.bindEmailError[0]')
                    } else if (data.code == 413) {
                        this.erorTips = this.$t('login.rule.authCode.requiredMsg')
                    } else if (data.code == 414) {
                        // 账号不存在
                        if (this.isCompleteEmail && this.thirdLoginInfo) {
                            const userInfo = JSON.stringify({
                                phone: this.thirdLoginInfo.mobile,
                                code: '',
                                email: this.form.email,
                                countDownTime: this.countDownTime,
                                areaCode: '',
                                thirdCode: this.thirdLoginInfo.code,
                                thirdEmail: this.form.email,
                                thirdName: this.thirdLoginInfo.nickname,
                                thirdPicture: this.thirdLoginInfo.picture,
                                type: this.thirdLoginInfo.type,
                                userId: this.thirdLoginInfo.userId,
                            })
                            window.localStorage.setItem('lookUserInfo', userInfo)
                            this.$router.push({
                                path: '/register',
                                query: {
                                    redirect: localStorage.getItem('redirect') || '/exception/report',
                                    type: 'thirdRegister',
                                }, // 'to.fullPath'跳转到登录之前页面的路径
                            })
                        } else {
                            // 更新用户信息
                            this.updateMemberEmail()
                        }
                    }
                })
                .catch(() => {
                    this.loginBtnState = false
                })
            if (this.isCompleteEmail) {
                return
            }
            // 给用户绑定邮箱
        },
        // 判断验证码长度
        validatorCode() {
            const code = this.form.code.replace(/\s*/g, '')
            if (code.length > 4) {
                this.form.code = code.substring(0, 4)
            }
            this.mobileSubmitDisabled()
        },
        //获取用户信息
        findCurrentMember() {
            this.$apollo
                .query({
                    query: findCurrentMember,
                    fetchPolicy: 'network-only',
                })
                .then((res) => {
                    const data = res.data.findCurrentMember
                    if (data && data.code === 200) {
                        this.memberInfo = data.data
                    }
                })
        },
        // 更新用户信息
        updateMemberEmail() {
            if (!this.memberInfo || this.memberInfo?.email || !this.form.email) {
                return
            }
            const param = {
                email: this.form.email,
            }
            this.$apollo
                .mutate({
                    mutation: updateMember,
                    variables: {
                        member: param,
                    },
                })
                .then((res) => {
                    const data = res.data.updateMember
                    if (data.code === 200) {
                        this.$router.go(-1)
                    }
                })
        },
    },
}
</script>

<style scoped lang="less">
.register-page {
    flex: 1;
    width: 100%;
    height: 100%;
    padding-top: 15px;
    background-image: linear-gradient(180deg, #262849, #07090f);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // justify-content: space-between;
    justify-content: initial;
    overflow: scroll;

    .areaCode {
        z-index: 999;
    }

    .navbar {
        width: 100%;
        height: 30px;
        padding-right: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .menu-info {
            width: 24px;
            height: 24px;
            margin-left: 8px;
        }

        /deep/ .van-icon-arrow-left:before {
            font-size: 14px;
            color: #fff;
        }
    }

    .el-dropdown-language {
        font-size: 12px;
        color: #fff;

        &::after {
            content: '';
            position: absolute;
            top: 55%;
            right: -14px;
            transform: translateY(-80%);
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #fff;
        }
    }

    .header {
        display: flex;
        height: 174px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 30px;

        .title {
            color: #fff;
            font-size: 22px;
        }

        h2 {
            height: 30px;
            mix-blend-mode: initial;
            color: #ffffff;
            font-family: PingFangSC;
            font-size: 21px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.14;
            letter-spacing: normal;
            text-align: center;
            -webkit-background-clip: text;
            background-clip: text;
            // -webkit-text-fill-color: transparent;
        }

        p {
            width: 300px;
            height: 34px;
            font-family: PingFangSC;
            mix-blend-mode: initial;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: center;
            color: #8aa3be;
            margin-top: 8px;
            margin-bottom: 34px;
        }
    }

    &.fi-FI {
        .header h2 {
            font-size: 20px;
        }
    }

    /deep/ .content .form .item {
        input:-internal-autofill-previewed,
        input:-internal-autofill-selected {
            -webkit-text-fill-color: #ffffff !important;
            transition: background-color 5000s ease-in-out 0s !important;
        }
    }

    .content {
        // flex: 1;
        // 表单
        .form {
            width: 100%;
            height: auto;

            .item {
                width: 345px;
                height: 56px;
                margin: 0 auto;
                border-radius: 4px;
                // background-color: #232440;
                background: #303c5c;
                padding: 0 16px;
                color: rgba(255, 255, 255, 1);
                margin-bottom: 8px;
                box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.24);
                display: flex;
                align-items: center;
                box-sizing: border-box;

                .area {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .no {
                        margin-right: 7px;
                    }

                    .arrow_bottom {
                        width: 0;
                        height: 0;
                        border-left: 6px solid transparent;
                        border-right: 6px solid transparent;
                        border-top: 6px solid #fff;
                    }
                }

                .info {
                    position: relative;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    /deep/ .van-field {
                        padding-left: 0;
                        // background-color: #232440;
                        background: #303c5c;
                    }

                    /deep/ .van-field__control {
                        color: #fff;
                        margin-left: 30px;
                        padding-left: 0px;
                    }

                    /deep/ .van-field__control::placeholder {
                        color: #6c6c6f;
                        font-size: 13.5px;
                    }

                    &.center {
                        justify-content: center;
                    }

                    .over {
                        position: absolute;
                        z-index: 10;
                        width: 100%;
                        height: 56px;
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.5);
                        line-height: 56px;
                        // pointer-events: none;
                        background-color: #303c5c;
                    }

                    .toggle-password {
                        .eye-icon {
                            width: 20px;
                            height: 20px;
                        }
                    }
                }

                label {
                    font-size: 14px;
                    text-align: left;
                }

                input {
                    width: 100%;
                    height: 56px;
                    background: transparent;
                    // padding-left: 46px;
                    font-size: 14px;
                    color: #fff;
                }

                .password-visible {
                    color: #fff;
                }

                .password-hidden {
                    //解决小米安全键盘回收留白底（防止调用安全键盘使用‘text’）
                    -webkit-text-security: disc;
                    text-security: disc;
                }

                /deep/ .van-field__control {
                    margin-left: 46px;
                }

                input[name='height'] ~ span {
                    font-size: 12px;
                    line-height: 12px;
                    color: rgba(255, 255, 255, 0.5);
                }

                .sex {
                    display: inline-block;
                    opacity: 0.5;
                    width: 40px;
                    height: 24px;
                    font-size: 14px;
                    line-height: 24px;
                    text-align: center;
                    margin: 0 20px;
                    border-radius: 4px;
                    border: 1px solid rgba(255, 255, 255, 1);

                    &.is-active {
                        opacity: 1;
                    }
                }

                .get-code-btn {
                    min-width: fit-content;
                    font-size: 12px;
                    color: #fff;

                    &.is-disabled {
                        opacity: 0.5;
                    }
                }
            }
        }
    }

    .footer {
        .login-tool {
            display: flex;
            width: 315px;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            margin-left: 14px;
            .left-view {
                width: 180px;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                text-align: left;
                .name {
                    font-size: 12px;
                    font-family: PingFangSC;
                    font-weight: 400;
                    color: #4a90e2;
                    margin-left: 5px;
                }
            }
            .name-view {
                width: 150px;
                font-size: 12px;
                font-family: PingFangSC;
                font-weight: 400;
                color: #4a90e2;
                margin-left: 5px;
                text-align: right;
            }

            .get-code-btn {
                width: 150px;
                text-align: right;
                font-size: 12px;
                color: #4a90e2;

                &.is-disabled {
                    opacity: 0.5;
                }
            }

            .image {
                width: 16px;
                height: 16px;
            }
        }

        .opacity {
            opacity: 0;
        }

        // 提交按钮
        .submit-btn {
            position: relative;
            margin-top: 32px;

            .error-tips {
                position: absolute;
                top: -25px;
                left: 50%;
                transform: translateX(-50%);
                font-size: 12px;
                color: #fe6363;
            }

            .create-account {
                text-align: center;
                font-size: 14px;
                color: #4a90e2;
                margin-top: 16px;
            }

            button {
                width: 200px;
                height: 40px;
                outline: none;
                border-radius: 6px;
                background-image: -webkit-gradient(linear, left top, right top, from(#00e3c9), to(#009fe8));
                background-image: -webkit-linear-gradient(left, #00e3c9, #009fe8);
                background-image: -o-linear-gradient(left, #00e3c9, #009fe8);
                background-image: linear-gradient(to right, #00e3c9, #009fe8);
                font-size: 16px;
                color: #fff;

                &.is-disabled {
                    border: 1px solid transparent;
                    background-image: linear-gradient(#191b31, #191b31),
                        /* 底色，即原有的背景 */ linear-gradient(to right, #06b0a2, #067eb9);
                    /* 模拟渐变边框 */
                    background-clip: padding-box, border-box;
                    background-origin: border-box;
                }

                .spinnerBtn {
                    display: flex;
                    justify-content: center;
                }

                /deep/ .mint-spinner-snake {
                    border: 2px solid transparent;
                }

                &.custom-btn {
                    width: 345px;
                    height: 40px;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    border-radius: 6px;
                    margin-top: 20px;
                }
            }
        }
    }

    .automatic-login {
        color: #fff;
        height: auto;
        font-size: 12px;
        display: flex;
        align-items: center;
        margin-top: 18px;

        i {
            font-style: normal;
            color: #8aa3be;
        }

        .checkbox {
            position: relative;
            height: 14px;
            width: 14px;
            border-radius: 50%;
            margin-right: 5px;
            border: 1px solid #fff;

            input {
                height: 12px;
                width: 12px;
                border-radius: 50%;
                opacity: 0;
            }

            &.is-check {
                &:before {
                    position: relative;
                    content: '';
                    height: 14px;
                    width: 14px;
                    margin: -1px;
                    border-radius: 50%;
                    // background: #00a4e6;
                    display: block;
                    overflow: hidden;
                    background: url('../../assets/images/comp_rb.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }

        span {
            color: #4a90e2;
        }
    }

    .third-view {
        display: flex;
        flex-direction: column;
        margin-top: 56px;
        .line-view {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .line {
                width: 127px;
                height: 1px;
                background-image: linear-gradient(
                    to right,
                    rgba(0, 227, 201, 0.2),
                    /* #00e3c9 透明度 20% */ rgba(0, 159, 232, 0.2) /* #009fe8 透明度 20% */
                );
            }
            .tips-view {
                font-size: 12px;
                color: #8aa3be;
                margin: 0 10px 0 10px;
            }
        }
        .third-login {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin-top: 24px;
            .name {
                font-size: 12px;
                color: #0091ff;
            }
        }
    }

    .icon-del {
        float: right;
        width: 9.5px;
        height: 9.5px;
        border-radius: 0.8px;
        background: url('../../assets/images/register/register_phone_delete.png') no-repeat;
    }

    .tips {
        position: relative;
        display: inline-block;
        font-size: 12px;
        height: 12px;
        line-height: 12px;
        min-width: 10px;
        color: #ffffff;
        margin-bottom: 30px;

        &::before {
            content: '*';
            position: absolute;
            width: 5px;
            left: -8px;
            top: 2px;
        }
    }

    &.ja-JP {
        .header p {
            width: 280px;
            line-height: 17px;
            margin-top: 20px;
        }

        .header {
            h2 {
                width: 268px;
            }
        }

        /deep/ .content .form .item {
            .get-code-btn {
                min-width: 60px;
                text-align: left;
            }
        }

        /deep/ .item:nth-child(2) {
            .van-field__control {
                margin-left: 22px;
            }
        }

        /deep/ input[name='verifyPassword'] {
            width: 104px;
            line-height: 20px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
        }

        div .error-tips {
            width: 314px;
            height: 34px;
        }

        /deep/ .van-cell__value {
            margin-left: 0px;
            text-align: left;
        }

        .custom-btn {
            margin-top: 10px !important;
        }
    }

    &.en-US,
    &.it-IT,
    &.fr-FR,
    &.ru-RU,
    &.es-ES,
    &.pt-PT,
    &.tr-TR,
    &.el-GR,
    &.cs-CZ,
    &.sv-SE,
    &.hu-HU,
    &.de-DE {
        .header p {
            width: 312px;
            line-height: 17px;
        }

        .checkbox {
            border: 1px solid #8aa3be !important;
        }

        i {
            color: #8aa3be;
        }

        .submit-btn {
            .error-tips {
                width: 300px;
            }
        }
    }

    &.es-ES,
    &.pt-PT {
        .codeLabel {
            width: 70px;
        }
    }

    &.pl-PL {
        .header p {
            width: 312px;
            line-height: 17px;
        }

        .checkbox {
            border: 1px solid #8aa3be !important;
        }

        i {
            color: #8aa3be;
        }

        .submit-btn {
            .error-tips {
                width: 300px;
            }
        }

        .content .form .item > label.codeLabel.codeLabel-item {
            width: max-content !important;
            min-width: 120px !important;
            max-width: none !important;
            flex: 0 0 auto !important;
            flex-shrink: 0 !important;
            white-space: nowrap !important;
            box-sizing: border-box;
        }
    }

    &.pt-PTO {
        .codeLabel-item {
            width: 80px;
        }
    }

    &.el-GR {
        .header p {
            width: 280px;
            line-height: 17px;
            margin-top: 23px;
        }
        .form .item input {
            font-size: 12px;
        }
    }

    &.ar-AR {
        direction: rtl;

        .iteminput {
            direction: ltr;
        }

        .itemyzm {
            direction: ltr;
            text-align: right;
        }

        .header {
            p {
                text-align: right;
            }
        }

        .search {
            padding-right: 10px;
        }

        /deep/.el-dropdown {
            margin-left: 20px;
        }

        /deep/.van-field__control {
            text-align: right;
        }

        .content .form .item input,
        .footer .rule i,
        .content .form .item .area .arrow_bottom {
            margin-right: 10px;
        }

        .footer .login-tool {
            margin-right: 14px;
        }

        .footer .login-tool .name-view {
            text-align: left;
            margin-left: 0px;
        }

        .footer .login-tool .get-code-btn {
            text-align: left;
        }

        .item .info .van-field__body {
            direction: ltr;
        }
        .right-text-left {
            margin-left: 10px;
        }
    }
    &.hu-HU,
    &.sv-SE {
        .content .item {
            padding-right: 0;
        }
        .get-code-btn {
            min-width: 40px !important;
        }
    }
}
</style>
<style>
/deep/.register-page {
    background-image: linear-gradient(180deg, #262849, #07090f) !important;
}

input[type='number'] {
    -moz-appearance: textfield;
}

input:-webkit-autofill {
    box-shadow: 0 0 0 1000px #303c5c inset;
    -webkit-text-fill-color: #fff;
}

input:-internal-autofill-previewed,
input:-internal-autofill-selected {
    -webkit-text-fill-color: #303c5c;
    transition: background-color 5000s ease-out 0.5s;
}

::-webkit-input-placeholder {
    color: #6c6c6f;
}

::-moz-placeholder {
    /* Firefox 19+ */
    color: #6c6c6f;
}

:-ms-input-placeholder {
    /* IE 10+ */
    color: #6c6c6f;
}

:-moz-placeholder {
    color: #6c6c6f;
}
</style>
